define('frontend-common-components/objectStorageConfig/js/helpers/storageHelper',[
    'underscore',
    'i18n!../../nls/objectStorageConfig',
    '../constants/storageConfigs'
], function (
    _,
    objectStorageMessageBundle,
    StorageConfigConstants
    ) {
    'use strict';
    var FilePrefixRegex = /^[0-9a-zA-Z!*.'()/_-]+$/;
    var DEFAULT_ACCEPTABLE_PREFIX_LENGTH = 100;
    var FilePrefixWithSlashRegex = /^[0-9a-zA-Z!*.'()\/_-]+\/$/;

    return {
        isValidFilePrefix: function (filePrefix) {
            if (_.isEmpty(filePrefix)) {
                return true;
            }
            return FilePrefixRegex.test(filePrefix);
        },

        isStoragePrefixLengthAcceptable: function (directoryPrefix, ACTUAL_ACCEPTABLE_PREFIX_LENGTH) {
            var acceptableLength = DEFAULT_ACCEPTABLE_PREFIX_LENGTH;
            if (ACTUAL_ACCEPTABLE_PREFIX_LENGTH) {
                acceptableLength = ACTUAL_ACCEPTABLE_PREFIX_LENGTH;
            }
            return directoryPrefix.length <= acceptableLength;
        },

        storagePrefixEndsWithSlash: function (filePrefix) {
            if (_.isEmpty(filePrefix)) {
                return false;
            }
            return FilePrefixWithSlashRegex.test(filePrefix);
        },

        getFullLocation: function (config) {
            var fullLocation;
            var prefix = config.filePrefix;
            var bucketOrContainerName = this.getBucketOrContainerName(config);

            if (_.isString(bucketOrContainerName) && bucketOrContainerName.length > 0) {
                fullLocation = bucketOrContainerName ;
            }

            if(_.isString(prefix) && prefix.length > 0) {
                fullLocation += '/' + prefix;
            }
            return fullLocation;
        },

        getStorageServiceName: function (storageType) {
            return objectStorageMessageBundle.storage.services[storageType];
        },

        getBucketOrContainerName: function (config) {
            if (config.storageType === StorageConfigConstants.Types.AWS) {
                return config.bucket;
            } else if (config.storageType === StorageConfigConstants.Types.Azure) {
                return config.container;
            }
        }
    };
});

